import {Component, ElementRef, inject, Input, ViewChild} from '@angular/core';
import {NgIf} from "@angular/common";
import {TranslatePipe} from "@ngx-translate/core";
import {EvidenceSvgPipe} from "../../pipes/evidence-svg.pipe";
import {APP_CONFIG} from "../../../app-config";

@Component({
    selector: 'app-id-card',
    standalone: true,
    imports: [
        NgIf,
        TranslatePipe,
        EvidenceSvgPipe
    ],
    templateUrl: './id-card.component.html',
    styleUrl: './id-card.component.scss'
})
export class IdCardComponent {

    appConfig = inject(APP_CONFIG);

    @Input() previewUrl: string | ArrayBuffer | null = null;
    @Input() name!: string | null | undefined;
    @Input() optionalLine1!: string | null | undefined;
    @Input() optionalLine2!: string | null | undefined;
    @Input() currentTime!: string | null | undefined;
    @Input() customWidth!: number;
    @Input() dynamicNameFontDevideNumber!: number;
    @Input() signType!: string;

    @ViewChild('idCardContainer') idCardElementRef!: ElementRef;

    ngAfterViewInit() {
        const element = this.idCardElementRef.nativeElement;

        const widthPx = element.getBoundingClientRect().width;

        const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);

        const widthRem = widthPx / rootFontSize;

        if(!this.signType) {
            this.signType = "basic";
        }

        setTimeout(() => {
            this.customWidth = widthRem;
        }, 300)
    }

}
